import React, {useEffect, useState} from 'react'
import Mapa from './Mapa'
import Tabla from './Tabla'
import axios from 'axios';
import qs from 'qs';
import { authUser } from '../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import {Box, Button, LinearProgress,FormControl, InputLabel, Select, MenuItem,
     RadioGroup, Radio,
     FormControlLabel,
     Grid,
     Typography, 
 } from "@material-ui/core";
import {llamaApiCargaToken,llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import { ordenMapBx } from '../MapaEdo/OrdenxMapBox';
import SearchIcon from '@material-ui/icons/Search';
import Relojes from "./Relojes";
import moment from 'moment';
const MapaRecorrido =()=>{
    const history = useHistory();
    const source = axios.CancelToken.source();
    const auxId =localStorage.getItem('UsuId') ; 
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0; 
    const Dispvo =localStorage.getItem('Dispvo') ;       
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs' 
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({
        inicio: new Date(),
        final: new Date(),
    });
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext);    
    const[lista, setLista]= useState([])
    const [espera,setEspera]= useState(false);
    const[bandera, setBandera]= useState(true)
    const [contador, setContador] = useState(1);
    const[periodo,setPeriodo]= useState("1A");  
    const[listDistrito,setListDistrito]= useState([]);  
    const[listPoliDto, setListPoliDto]= useState([]);  
    const[listPoliOtb, setListPoliOtb]= useState([]); 
    const[listColOtb, setListColOtb]= useState([]); 
    const[listColPolig, setListColPolig]= useState([]); 
    const[listMarcador, setListMarcador]= useState([]);   
    const[listNumOtb, setListNumOtb]= useState([]);   
    const[listRecorrido, setListRecorrido]= useState([]);   
    const [listTipo, setListTipo] = useState([]);
    const[distrito, setDistrito]= useState(0);  
    const[rutaSeleccion, setRutaSeleccion]= useState([]);  
    const [cargando, setCargando] = useState(false);
    const [tipo, setTipo] = useState("");

        useEffect(()=>{             
            const autenticado = authUser();
            if(!autenticado){
                localStorage.clear();
                history.push("/");
                guardarUsuario([])
            }
            else
            {   const usu= localStorage.getItem('UsuarioNom');                 
                if (usuario.length===0) 
                {
                    guardarUsuario({Nombre:usu,nivel:nvl});                                                               
                }                      
                getListTipo()
                getListDto()
                guardarGenerales({...generales,Titulo:'Mapa Recorridos'})      
                    
            }
            
            return ()=> {
                source.cancel();
            }      
        //la siguiente linea puede generar errores o no en el useEffect
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

     const getListTipo = () => {
        const data = qs.stringify({            
            Usuario: auxId,
            idDispositivo: "987gyubjhkkjh",
        });
        const url = "recorrido-tipo";

        function respuesta(response) {
            if (response[0].Id === -1) {
                setListTipo([]);
                
            } else {
                setListTipo(response);
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
    };
    

    function getListDto()  {            
        const auxU= `lugar/municipio/distrito`;                            
        const dataInfo = qs.stringify({                
            Usuario:auxId,     
            Estado: process.env.REACT_APP_EDO,  ip:"127.0.0.0",                      
            idDispositivo:auxDispV,
            });
                    
        function respuesta (auxiliar) 
        {   if (auxiliar[0].Id !== -1) 
            {   let listNvo=[]
                auxiliar.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom} - ${element.ComNom}`})
                });                                                 
                setListDistrito(listNvo) 
            }                                                            
        }
        llamadaApiToken(dataInfo, auxU, respuesta, ErrorGeneral,  history, source);
    };
    
    const getListPoliDto = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito/gps";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr=[]
              //  console.log([auxiliar[0].Ln.toFixed(5), auxiliar[0].Lat.toFixed(5)]);
                auxiliar.forEach((poligono)=>{                                        
                  auxArr.push([poligono.Ln, poligono.Lt])
                  //auxArr.push({coordinates:[poligono.Ln, poligono.Lt]})
                })
                //console.log(auxArr);
                
                setListPoliDto(auxArr)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListPoliOtb = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito/otb/gps";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr2=[], auxArr3=[], auxListOtb=[], auxCol=[]                            
                //auxArr[0]=[]                auxArr[1]=[]           
                    
                auxCol=["match",["get", "IdOTB"]]
                auxiliar[0].otb.forEach((element)=>{
                    let nvoArr=[]
                    if (element.gps) {
                        element.gps.forEach((poligono)=>{
                            nvoArr.push([poligono.Ln, poligono.Lt])
                        })     
                        
                        auxArr2.push({ 
                            "id":element.Id,
                            'type': 'Feature',
                            "properties":{
                                "IdOTB":element.Id, 
                                "colOtb":element.Col
                            },
                            "nomOtb":element.Nom,                                
                            'geometry': {                        
                                'type': 'MultiPolygon',                         
                                'coordinates': [[nvoArr]]
                            }
                        })
                        auxCol.push(element.Id)      
                        auxCol.push(element.Col)  
                        auxListOtb.push({...element, coordinates:[element.Ln, element.Lt]})         
                    }
                    
                })                    
                auxCol.push('#cedded')                   
                    
                auxArr3={"type": "FeatureCollection",
                    "name": "Cochabamba",
                    "features":auxArr2}
             
                setListNumOtb(auxListOtb)
                setListColPolig(auxCol)                                                   
                setListPoliOtb(auxArr3)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListMarcador = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/recinto/dto";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr=[]              
                auxiliar.forEach((poligono)=>{                                        
                  auxArr.push({coordinates:[poligono.ln, poligono.lt], original:poligono})                  
                })                
                setListMarcador(auxArr)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListRecorrido = (Distrito) => {
        const fInicio = moment(fechasSeleccionadas.inicio).format("YYYY-MM-DD")
        const fFinal = moment(fechasSeleccionadas.final).format("YYYY-MM-DD")
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId,  
            Distrito:Distrito.length!==0 ? Distrito:0,
            Tipo:tipo,
            Fini: fInicio + 'T00:00:00',
            Ffin: fFinal + 'T23:59:59',
            idDispositivo: auxDispV,
        });
        const url = "recorrido/v3/list";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
                setListRecorrido(auxiliar)
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const limpiar =()=>{
        localStorage.removeItem("auxPol")
        setBandera(false)
        setLista([])
        setContador(1)
    }

    const funcionUltimo =()=>{
        let auxLocalStg =  localStorage.getItem('auxPol') ?  JSON.parse(localStorage.getItem('auxPol')):[]
        if (auxLocalStg.length!==0) {
            if (auxLocalStg.length===1) {
                limpiar()
            }
            else{
                auxLocalStg.pop()
                localStorage.setItem('auxPol',JSON.stringify(auxLocalStg))
                setContador(contador-1)
                setBandera(false)
            }            
        }        
    }

    const onChangeRad=(e)=>{
       setPeriodo( e.target.value)                                                           
    }

    const onChange = e => {
        setTipo( e.target.value)
    }

    const onChangeDto=(e)=>{    
        if (e!== null && e!== undefined) 
        { //setMuniSelect(e)               
            setDistrito(e.target.value)    
            setListPoliDto([])
            setListPoliOtb([])
            setListMarcador([])
            getListPoliDto(e.target.value)  
            getListPoliOtb(e.target.value)  
            getListMarcador(e.target.value)  
            getListRecorrido(e.target.value)  
            
        }else
        {   setDistrito("")           
        }               
    } 

     const generarLista=( )=>{    
        if (distrito.length!==0) 
        {  
            setListPoliDto([])
            setListPoliOtb([])
            setListMarcador([])
            getListPoliDto(distrito)  
            getListPoliOtb(distrito)  
            getListMarcador(distrito)  
            getListRecorrido(distrito)
            
        }   
        else{
            getListRecorrido("")
        }          
    } 

    return(
    <Box display={"flex"} flexDirection={"column"}>
        <Box display={"flex"} flexDirection={"row"}>
             <Box mr={1} >       
                <Button onClick={generarLista} style={{width:"7rem", marginTop:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
                    variant="contained"  color="primary"  startIcon={<SearchIcon/>} 
                    disabled={espera}
                >   
                    Buscar     
                </Button>                                                                                                                        
            </Box>
            <Box  >
                <Relojes
                    fechasSeleccionadas={fechasSeleccionadas}
                    setFechasSeleccionadas={setFechasSeleccionadas}
                />
            </Box>
            <Box  ml={1} >
                {listTipo.length !== 0 ?
                <FormControl size="small">
                    <InputLabel htmlFor="Tipo">Tipo</InputLabel>
                    <Select native value={tipo}   onChange={onChange}
                        inputProps={{name: 'tipo', id: 'tipo',}} style={{width:"10rem"}}
                    >
                        {listTipo.map(element => {
                            if (element.Id===0) {
                                return <option key={element.Id} value={element.Id}>
                                Todos</option>
                            }else{
                                return <option key={element.Id} value={element.Id}>
                                {element.Nom}</option>
                            }
                            
                        })}
                    </Select>
                </FormControl>
                : null
                }
            </Box>   
            { listDistrito.length!==0 ?                
            <Box display={"flex"} mb={2} mt={1} ml={1}>
            <FormControl size='small'  style={{ minWidth:10+'rem'}} >
                <InputLabel size='small' variant="outlined" id="distrito-label-nvo">Distrito</InputLabel>
                <Select  size='small' variant="outlined"    
                    label="Distrito" id="Distrito-select2" name="distrito"
                    value={distrito} onChange={onChangeDto}
                >
                    <MenuItem size='small' value={0} key={1}>
                        <em>Todos</em>
                    </MenuItem>
                    {listDistrito.map((secc, index) => {
                        if(secc.Id>0) {
                        return(
                        <MenuItem size='small' value={secc.Id} key={secc.Id+1}>
                            <em>{secc.Nom }</em>
                        </MenuItem>
                        )}                        
                    } )}                    
                </Select>
                </FormControl>
                </Box>
            :   null
            }
          {/*   <FormControl component="fieldset" style={{marginLeft:.5+'rem', marginTop:".5rem" }}>          
               
                <RadioGroup  row aria-label="position"  defaultValue="top"
                    name="periodo" value={periodo} onChange={onChangeRad}
                >                        
                    <FormControlLabel value={"1A"}  label={"Primer Periodo"}
                        style={{}}
                        control={<Radio color="primary" />} />
                    <FormControlLabel value={"2A"}  label={"Segundo Periodo"}
                        style={{}}
                        control={<Radio color="primary" />} />                                                                      
                </RadioGroup>                     
            </FormControl>   */}
        </Box>     
        <Box display={"flex"} flexDirection={"row"}>
        <Box  ml={1} style={{position:"relative"}} >
            {!espera  
             ? 
                <Mapa lista={listPoliDto} setLista={setLista} setActualiza={()=>setBandera(!bandera)} 
                    contador={contador} setContador={setContador} listMarcador={listMarcador} 
                    listPoliOtb={listPoliOtb}  listNumOtb={listNumOtb} rutaSeleccion={rutaSeleccion}
                    listColPolig={listColPolig}  listRecorrido={listRecorrido}
                />
            : espera ?<Box mt={5}><LinearProgress/></Box>
            : listRecorrido.length===0 ? <Typography variant='h3'>Sin recorridos</Typography>:null}
        </Box>
        <Box style={{position:"absolute",  }}>
           {listRecorrido.length!==0 ? <Tabla lista={listRecorrido} bandera={bandera} setRutaSeleccion={setRutaSeleccion} />
            : listRecorrido.length===0 ? <Typography variant='h3' style={{marginLeft:"1rem"}}>Sin recorridos</Typography>:null}
          {/*   <Button onClick={limpiar}>Limpiar</Button>
            <Button onClick={funcionUltimo} style={{marginLeft:"1rem", }}>Borrar ultimo</Button>
            */}
        </Box>
        </Box>   
    </Box>)
}

export default MapaRecorrido